package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.Color.Companion.BLACK
import com.downdogapp.ObjectFit.COVER
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Size.INHERIT
import com.downdogapp.client.resources.Image
import com.downdogapp.client.resources.image
import kotlinx.dom.clear
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

class Background(parent: HTMLElement, blur: Boolean, val image: Image?) {

  private var backgroundImageContainer: HTMLDivElement

  val root = createDiv {
    position = ABSOLUTE
    height = INHERIT
    width = INHERIT

    bgColor = BLACK

    backgroundImageContainer = div {
      position = ABSOLUTE
      height = INHERIT
      width = INHERIT
    }

    if (blur) {
      blurView()
    }

    // Stop propagation of click event
    onClick(cursorPointer = false)
  }

  init {
    parent.appendChild(root)
    refresh()
  }

  fun refresh() {
    backgroundImageContainer.clear()
    image?.let {
      backgroundImageContainer.img {
        this.image = it
        (this as HTMLElement).width = Size.percent(100)
        (this as HTMLElement).height = Size.percent(100)
        objectFit = COVER
      }
    }
  }
}
